import React from 'react';
import PropTypes from 'prop-types';
import ProjectBreadcrumbs from '../project/project-hero/project-breadcrumb';
import ProjectHeadline from '../project/project-hero/project-headline';
import HeroMessage from '../hero/hero-message';
import HeroBGImage from './hero-bg-image';
import ScrollDown from '../scroll-down';
import GradientBGTransition from '../gradient-bg-transition';
import { css } from 'emotion';
import styles from './hero.module.css';

const HeroAwkward = ({
  title,
  preTitle,
  browserDetect,
  heroBGImage,
  heroBGMobileImage,
  contentWidth,
}) => {
  const renderContentStyle = () => {
    if (typeof contentWidth !== 'undefined') {
      return [
        styles.content,
        css`
          @media (min-width: 1100px) {
            width: ${contentWidth};
          }
        `,
      ].join(' ');
    } else {
      return styles.content;
    }
  };

  return (
    <div
      className={
        browserDetect === 'iOS'
          ? [styles.wrapper, styles.wrapperIOS].join(' ')
          : styles.wrapper
      }
    >
      <div className={styles.container}>
        <div className={renderContentStyle()}>
          <div>
            <ProjectBreadcrumbs
              preTitle={preTitle}
              title={title}
              color="#8237B7"
            />
            <ProjectHeadline
              headline={title}
              colorOverride="#2AD9C7"
              fontOverride="montheavy"
            />
          </div>
        </div>
      </div>
      <ScrollDown color="black" />
      <div className={styles.imageDesktopWrapper}>
        {typeof heroBGImage !== 'undefined' && (
          <HeroBGImage heroBGImage={heroBGImage} />
        )}
      </div>
      <div className={styles.imageMobileWrapper}>
        {typeof heroBGMobileImage !== 'undefined' && (
          <HeroBGImage heroBGImage={heroBGMobileImage} />
        )}
      </div>
    </div>
  );
};

HeroAwkward.propTypes = {};

export default HeroAwkward;



// WEBPACK FOOTER //
// ./src/components/hero-awkward/index.js